export const ROLES = Object.freeze({
  STUDENT: "student",
  TEACHER: "teacher",
  ADMIN: "admin",
  SUPERADMIN: "superadmin",
  TECH: "123wellness",
});

export const ALL_ROLES = Object.values(ROLES);
export const EDUCATOR_ROLES = [
  ROLES.TEACHER,
  ROLES.ADMIN,
  ROLES.SUPERADMIN,
  ROLES.TECH,
];
